
export const MESSAGES_SHOW = 'MESSAGES_SHOW';




// WEBPACK FOOTER //
// ./src/data/messages/types.js